import "core-js/modules/es.array.concat.js";
import { homeCrumb } from "../../util/breadcrumbs";
export var agentStudentsCrumb = function agentStudentsCrumb(_ref) {
  var agentEmail = _ref.agentEmail,
    onClick = _ref.onClick;
  return {
    text: 'Students',
    href: "/students?".concat(encodeURIComponent("grid[f][agents_users.email]=".concat(agentEmail))),
    onClick: onClick
  };
}; // TODO - this resource might be at a different location
export var agencyNameCrumb = function agencyNameCrumb(_ref2) {
  var agencyName = _ref2.agencyName,
    agentId = _ref2.agentId,
    isInternalUser = _ref2.isInternalUser,
    isAgentStaff = _ref2.isAgentStaff;
  return {
    text: isInternalUser ? "".concat(agencyName, " [").concat(isAgentStaff ? 'Staff' : 'Owner', "]") : agencyName,
    href: "/agents/".concat(agentId),
    onClick: function onClick() {}
  };
};
export var studentCrumb = function studentCrumb(_ref3) {
  var studentName = _ref3.studentName,
    studentId = _ref3.studentId,
    isInternalUser = _ref3.isInternalUser,
    onClick = _ref3.onClick;
  return {
    text: isInternalUser ? "[".concat(studentId, "] ").concat(studentName) : studentName,
    href: "/students/".concat(studentId),
    onClick: onClick
  };
};
export var studentApplicationsCrumb = function studentApplicationsCrumb(_ref4) {
  var studentId = _ref4.studentId,
    isStudent = _ref4.isStudent,
    onClick = _ref4.onClick;
  return {
    text: 'Applications',
    href: isStudent ? '/my_applications' : "/students/".concat(studentId, "/applications"),
    onClick: onClick
  };
};
export var submittedApplicationsCrumb = function submittedApplicationsCrumb(_ref5) {
  var onClick = _ref5.onClick;
  return {
    text: 'Applications',
    href: '/applications?paid=1&submitted=1',
    onClick: onClick
  };
};
export var applicationCrumb = function applicationCrumb(_ref6) {
  var applicationId = _ref6.applicationId,
    programName = _ref6.programName,
    schoolName = _ref6.schoolName;
  return {
    text: "[".concat(applicationId, "] ").concat(programName, " @ ").concat(schoolName)
  };
};
export var agentsCrumb = {
  text: 'Recruitment Partners',
  href: '/agents'
};
var studentsCrumb = {
  text: 'Students',
  href: '/students'
};
var getApplicationBreadcrumbs = function getApplicationBreadcrumbs(_ref7) {
  var initialProps = _ref7.initialProps,
    currentUser = _ref7.currentUser,
    trackEvent = _ref7.trackEvent;
  if (!(initialProps && initialProps.application && initialProps.temp_additional)) {
    return [];
  }
  var currentUserIsStudent = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === 'student';
  var currentUserIsSchoolAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === 'school_admin';
  var application = initialProps.application,
    temp_additional = initialProps.temp_additional;
  var breadcrumbs = [homeCrumb(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, currentUser === null || currentUser === void 0 ? void 0 : currentUser.role, function () {
    if (trackEvent) {
      trackEvent({
        event: 'Single Application - Breadcrumb Menu - Clicked Home'
      });
    }
  })];
  if (temp_additional.agency_name && temp_additional.can_administer_agent) {
    breadcrumbs.push(agentsCrumb);
    breadcrumbs.push(agencyNameCrumb({
      agencyName: temp_additional.agency_name,
      agentId: temp_additional.agent_id,
      isInternalUser: temp_additional.current_internal,
      isAgentStaff: temp_additional.agent_staff
    }));
    breadcrumbs.push(agentStudentsCrumb({
      agentEmail: temp_additional.agent_email,
      onClick: function onClick() {
        if (trackEvent) {
          trackEvent({
            event: 'Single Application - Breadcrumb Menu - Clicked Students'
          });
        }
      }
    }));
  } else if (!currentUserIsStudent && !currentUserIsSchoolAdmin) {
    studentsCrumb.onClick = function () {
      if (trackEvent) {
        trackEvent({
          event: 'Single Application - Breadcrumb Menu - Clicked Students'
        });
      }
    };
    breadcrumbs.push(studentsCrumb);
  }
  if (!currentUserIsStudent && !currentUserIsSchoolAdmin) {
    breadcrumbs.push(studentCrumb({
      studentName: temp_additional.student_name,
      studentId: application.user_id,
      isInternalUser: temp_additional.current_internal,
      onClick: function onClick() {
        if (trackEvent) {
          trackEvent({
            event: 'Single Application - Breadcrumb Menu - Clicked Student Name'
          });
        }
      }
    }));
  }
  if (currentUserIsSchoolAdmin) {
    breadcrumbs.push(submittedApplicationsCrumb({
      onClick: function onClick() {
        if (trackEvent) {
          trackEvent({
            event: 'Single Application - Breadcrumb Menu - Clicked Applications'
          });
        }
      }
    }));
  } else {
    breadcrumbs.push(studentApplicationsCrumb({
      studentId: application.user_id,
      isStudent: currentUserIsStudent,
      onClick: function onClick() {
        if (trackEvent) {
          trackEvent({
            event: 'Single Application - Breadcrumb Menu - Clicked Applications'
          });
        }
      }
    }));
  }
  breadcrumbs.push(applicationCrumb({
    applicationId: initialProps.id,
    programName: temp_additional.program,
    schoolName: temp_additional.school
  }));
  return breadcrumbs;
};
export default getApplicationBreadcrumbs;